import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import '../plugins/flatpickr';
import {Czech} from 'flatpickr/dist/l10n/cs';
import {forEach} from "ramda";

export default class Calendar extends WebComponent {

  didMount() {
    const {
      url,
    } = this.props;

    const calendar = this.element;
    let localeArray = [{lang: 'cs', locale: Czech}, {lang: 'en', locale: null}];
    const currentLocale = localeArray.filter(item => item.lang === window.projectConfig.lang);

    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', url, true);
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status === 200) {
          var json = JSON.parse(xmlhttp.responseText);
          var eventData = json.data;
          initFlatpicker(eventData);
        }
      }
    };
    xmlhttp.send(null);

    // empty value for link collection. This is to reset value as use hovers over
    let eventLinkHref = 'empty';

    /**
     * Creates container with individual bullets inside flatpickr day
     * @param dayElem
     */
    function createPopUpAndBullets(dayElem) {
      // pop up
      dayElem.innerHTML += '<div id="jsEventDetailPopup" class="event-detail-popup js_eventDetailPopup"></div>';
      // bullets
      dayElem.innerHTML += `
      <div id="jsEventDetailBulletsContainer" class="event-detail-bullets-container">
        <span data-faculty="uhk" class="event-detail-bullet event-detail-bullet--uhk">&nbsp;</span>
        <span data-faculty="ff" class="event-detail-bullet event-detail-bullet--ff">&nbsp;</span>
        <span data-faculty="fim" class="event-detail-bullet event-detail-bullet--fim">&nbsp;</span>
        <span data-faculty="prf" class="event-detail-bullet event-detail-bullet--prf">&nbsp;</span>
        <span data-faculty="pdf" class="event-detail-bullet event-detail-bullet--pdf">&nbsp;</span>
      </div>`;
    }

    /**
     * format day and month format
     * @param date
     */
    function prependDateZero(date) {
      if (date.length < 2) {
        return '0'+date;
      } else {
        return date;
      }
    }

    /**
     * returns current date
     * @param today
     */
    function currentDate(today) {
      let dd = today.getDate(),
          mm = today.getMonth()+1, //As January is 0.
          yyyy = today.getFullYear();

      if(dd<10) dd='0'+dd;
      if(mm<10) mm='0'+mm;
      return (yyyy+'-'+mm+'-'+dd);
    }

    /**
     * Push event to prepared popup
     * @param dayElem
     * @param facultyType
     * @param facultyTitle
     * @param eventTitle
     * @param eventUrl
     * @param singleEventStart
     * @param meStart
     * @param meEnd
     */

    function pushEventToPopUp(dayElem, facultyType, facultyTitle, eventTitle, eventUrl, singleEventStart, meStart, meEnd) {
      // fill the dropdown and popup with event data
      const popup = dayElem.querySelector('.js_eventDetailPopup');
      const eventLink = document.createElement("p");
      eventLink.classList.add('event-detail-link');
      if (singleEventStart) {
        let seStartSeparated = singleEventStart.split("-"),
            dd = seStartSeparated[1],
            mm = seStartSeparated[0],
            yyyy = seStartSeparated[2],
            hours = seStartSeparated[3],
            mins = seStartSeparated[4];
        let seStartTime = `${hours}&colon;${mins}`;
        if(hours == '00' && mins == '00' || hours == '23' && mins == '59') {
          seStartTime = '';
        }

        if(document.documentElement.lang === "cs"){
          eventLink.innerHTML = `
        <span class="color-${facultyType}">
            <span>${facultyTitle}</span>
            <span>&#8729;</span>
            <span>${dd}&period;&nbsp;${mm}&period;&nbsp;${seStartTime}</span>
          </span>
          <a href="${eventUrl}">${eventTitle}</a>`;
        } else {
          eventLink.innerHTML = `
        <span class="color-${facultyType}">
            <span>${facultyTitle}</span>
            <span>&#8729;</span>
            <span>${dd}&sol;${mm}&nbsp;${seStartTime}</span>
          </span>
          <a href="${eventUrl}">${eventTitle}</a>`;
        }


        eventLink.setAttribute('data-fragment','singleDay.ITEM');
        eventLink.setAttribute('data-date-from', yyyy+'-'+prependDateZero(mm)+'-'+prependDateZero(dd));

        popup.appendChild(eventLink);
      }
      if (meStart) {
        let meStartSeparated = meStart.split("-"),
            meEndSeparated = meEnd.split("-"),
            meSdd = meStartSeparated[1],
            meSmm = meStartSeparated[0],
            meSyyyy = meStartSeparated[2],
            meShours = meStartSeparated[3],
            meSmins = meStartSeparated[4],
            meEdd = meEndSeparated[1],
            meEmm = meEndSeparated[0],
            meEyyyy = meEndSeparated[2],
            meEhours = meEndSeparated[3],
            meEmins = meEndSeparated[4];
        let meStartTime = `&nbsp;${meShours}&colon;${meSmins}`;
        if(meShours == '00' && meSmins == '00' || meShours == '23' && meSmins == '59') {
          meStartTime = '';
        }
        let meEndTime = `${meEhours}&colon;${meEmins}`;
		let timeBreakStart = '';
		let timeBreakEnd = '';
		let timeBreakTag = '&ndash;';
        let meEDate;
        document.documentElement.lang === "cs" ? meEDate = `&nbsp;${meEdd}&period;&nbsp;${meEmm}&period;` : meEDate = `${meEmm}&sol;${meEdd}`;

        let differentTime = (meEhours != '00' && meEmins != '00' || meEhours != '23' && meEmins != '59') && (meShours != '00' && meSmins != '00' || meShours != '23' && meSmins != '59');
        if(meSdd+'.'+meSmm == meEdd+'.'+meEmm) {
          meEDate = '';
          if(meEhours == '00' && meEmins == '00' || meEhours == '23' && meEmins == '59') {
            meEndTime = '';
            if(meShours == '00' && meSmins == '00' || meShours == '23' && meSmins == '59') {
		      timeBreakTag = '';
            }
          }
        } else {
			if(differentTime) {
              timeBreakStart = '<br/><span class="time-identation">';
              timeBreakEnd = '</span>';
			}
		}
        if(meEhours == '00' && meEmins == '00' || meEhours == '23' && meEmins == '59') {
          meEndTime = '';
        }
        if(meShours == meEhours && meSmins == meEmins) {
          meEndTime = '';
          timeBreakTag = '';
        }
        if(document.documentElement.lang === "cs"){
          eventLink.innerHTML = `
        <span class="color-${facultyType}">
            <span>${facultyTitle}</span>
            <span>&#8729;</span>
            <span>${meSdd}&period;&nbsp;${meSmm}&period;${meStartTime}${timeBreakTag}${timeBreakStart}${meEDate}${meEndTime}${timeBreakEnd}</span>
          </span>
          <a href="${eventUrl}">${eventTitle}</a>`;
        } else {
          eventLink.innerHTML = `
        <span class="color-${facultyType}">
            <span>${facultyTitle}</span>
            <span>&#8729;</span>
            <span>${meSmm}&sol;${meSdd}&nbsp;${meStartTime}${timeBreakTag}${timeBreakStart}${meEDate}${meEndTime}${timeBreakEnd}</span>
          </span>
          <a href="${eventUrl}">${eventTitle}</a>`;
        }
        eventLink.setAttribute('data-fragment','multiDay.ITEM');
        eventLink.setAttribute('data-date-from', meSyyyy+'-'+prependDateZero(meSmm)+'-'+prependDateZero(meSdd));
        eventLink.setAttribute('data-date-to', meEyyyy+'-'+prependDateZero(meEmm)+'-'+prependDateZero(meEdd));
        popup.appendChild(eventLink);
      }
    }

    /**
     * FLATPICKR INIT
     * @param eventData
     */
    function initFlatpicker(eventData) {
      flatpickr(calendar, {
        "locale": currentLocale[0].locale,
        inline: true,
        dateFormat: document.documentElement.lang === "cs" ? 'd-m-Y' : 'm-d-Y',
        ariaDateFormat: document.documentElement.lang === "cs" ? 'd-m-Y' : 'm-d-Y',
        onDayCreate: function (dObj, dStr, fp, dayElem) {
          /** each day will get 2 containers appended.
           * 1. `event-detail-popup` (this will display on hover and contains data)
           * 2. `event-detail-bullet-container` (this will get filled with dots)
           * */
          createPopUpAndBullets(dayElem);

          /**
           * Loop each day in JSON and distribute events accordingly
           * */
          for (var i = 0; i < eventData.length; i++) {

            const fpD = dayElem.dateObj.getTime(),
                  facultyType = eventData[i].facultyType,
                  facultyTitle = eventData[i].facultyTitle,
                  eventUrl = eventData[i].eventUrl,
                  eventTitle = eventData[i].eventTitle,
                  seStart = eventData[i].singleEventStart,
                  meStart = eventData[i].multipleEventStart,
                  meEnd = eventData[i].multipleEventEnd;
            let   seS,
                  meS,
                  meE;

            if (seStart != null) {
                let seStartSeparated = seStart.split("-");
                seS = new Date(seStartSeparated[2],seStartSeparated[0] - 1,seStartSeparated[1]).getTime();
            }
            if (meStart != null) {
                let meStartSeparated = meStart.split("-");
                meS = new Date(meStartSeparated[2],meStartSeparated[0] - 1,meStartSeparated[1]).getTime();
            }
            if (meEnd != null) {
                let meEndSeparated = meEnd.split("-");
                meE = new Date(meEndSeparated[2],meEndSeparated[0] - 1,meEndSeparated[1]).getTime();
            }

            /**
             * !!! Single day events !!!
             * */
            if(seStart) {
              if (seS === fpD) {
                // add class so we manipulate popup natively with onChange event
                dayElem.classList.add("has-events");
                dayElem.tabIndex = 0;
                // show according bullet
                if(facultyType != "") dayElem.querySelector('.event-detail-bullet--' + facultyType + '').classList.add("active");
                pushEventToPopUp(dayElem, facultyType, facultyTitle, eventTitle, eventUrl, seStart);
              }
            }

            /**
             * !!! Multiple days events !!!
             */
            if(meStart) {
              if (fpD >= meS && fpD <= meE) {
                // add class so we manipulate popup natively with onChange event
                dayElem.classList.add("has-events");
                dayElem.tabIndex = 0;
                // show according bullet
                  if(facultyType != "") dayElem.querySelector('.event-detail-bullet--' + facultyType + '').classList.add("active");
                pushEventToPopUp(dayElem, facultyType, facultyTitle, eventTitle, eventUrl, seStart, meStart, meEnd);
              }
            }
          }
        },
        onReady: function (dateObj, dateStr, instance) {
          // sortEventsByDays();
          initLinks();
        },
        onMonthChange: function (dateObj, dateStr, instance) {
          const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (windowWidth > 1200) {
            // sortEventsByDays();
          }
          initLinks();
        },
        onChange: function (selectedDates, dateStr, instance, e) {
          // fill container with content of the pop up for small screens
          const eventDetailContainer = document.querySelector('.js_eventDetailContainer');
          const popUpContent = instance.selectedDateElem.firstElementChild.innerHTML;

		  eventDetailContainer.classList.add('active');
		  eventDetailContainer.innerHTML =  popUpContent;
		  setTimeout(function() {
		    // sortEventsByDays();
            const popUpTitle = document.createElement("h4");
            popUpTitle.classList.add('event-detail-container-header');
            popUpTitle.innerHTML = "Události dne " + instance.selectedDateElem.firstChild.nodeValue + ".&nbsp;" + (instance.currentMonth + 1) + ".&nbsp;" + instance.currentYear;
            eventDetailContainer.insertBefore(popUpTitle, eventDetailContainer.firstChild);
          },300);
          // clear container
          // get window width
          const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          // scroll only on small screens on day elements with events
          if (instance.selectedDateElem.classList.contains('has-events')) {
            if (windowWidth < 1200) {
              eventDetailContainer.scrollIntoView(false);
              window.scrollBy(0, +300);
            } else {
              goToLink(eventLinkHref);
            }
          }
        },
        onYearChange: function (dateObj, dateStr, instance) {
          const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (windowWidth > 1200) {
            // sortEventsByDays();
          }
          initLinks();
          //distributeMultipleEvents();
        },
        nextArrow: '<svg class="svg-icon"><use xlink:href="#arrow-right"></use></svg>',
        prevArrow: '<svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg>',
      });

      let callSortOnlyOnce = true;
      window.addEventListener("resize", function() {
        const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if(windowWidth > 1200){
          if(callSortOnlyOnce) {
            // sortEventsByDays();
            callSortOnlyOnce = false;
          }
        } else {
          callSortOnlyOnce = true;
        }

      });

      function initLinks() {
        const eventLinks = document.querySelectorAll('.event-detail-link a');
        const eventDays = document.querySelectorAll('.flatpickr-day.has-events');

       eventDays.forEach(function(day) {
          day.addEventListener('focus', function(e) {
            eventDays.forEach(function(day) {
              day.classList.remove('focus');
            });
            day.classList.add('focus');
          })
        });

        document.addEventListener('mouseover', function (e) {
          for (var i = 0; i < eventDays.length; i++) {
            if (e.target === eventDays[i]) {
              eventLinkHref = eventDays[i].querySelector('a').getAttribute('href');
            }
          }
          for (var i = 0; i < eventLinks.length; i++) {
            if (e.target === eventLinks[i]) {
              eventLinkHref = eventLinks[i].getAttribute('href');
            }
          }
          eventDays.forEach(function(day) {
            day.classList.remove('focus');
          });
        });
        return eventLinkHref;
      }
      function goToLink(eventLinkHref) {
        initLinks();
        // go to loaded link on mouse over
        if (eventLinkHref !== "empty") {
          location.href = eventLinkHref;
        }
      }
      // function sortEventsByDays() {
      //   let days = document.querySelectorAll('.js_eventDetailPopup');
      //   // get window width
      //   const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      //   if (windowWidth < 1200) {
      //      days = document.querySelectorAll('.js_eventDetailContainer');
      //   }
      //   days.forEach(function(popup) {
      //     const singleDayItems = [...popup.querySelectorAll('p[data-fragment="singleDay.ITEM"]')],
      //           multiDayItems = [...popup.querySelectorAll('p[data-fragment="multiDay.ITEM"]')],
      //           dateNow = currentDate(new Date()),
      //           singleDayData = singleDayItems.map((itemElement) => {
      //             let current = false;
      //             if (itemElement.dataset.dateFrom == dateNow) current = true;
      //           return {
      //             date: itemElement.dataset.dateFrom,
      //             current: current,
      //             el: itemElement
      //           };
      //         }),
      //         multiDayData = multiDayItems.map((itemElement) => {
      //           return {
      //             date: itemElement.dataset.dateFrom,
      //             el: itemElement
      //           };
      //         });
      //
      //     let currentEvents = [];
      //     singleDayData.forEach(function(dayItem) {
      //       if(dayItem.current) {
      //         currentEvents.push(dayItem);
      //       }
      //     });
      //
      //     let lastArrayItem = currentEvents.slice(-1).pop();
      //
      //     if (lastArrayItem) {
      //       let lastCurrentElement = lastArrayItem.el;
      //       multiDayData.reverse().forEach(function(dayItem) {
      //         // if (dayItem.date < dateNow) {
      //           dayItem.el.parentNode.insertBefore(dayItem.el, lastCurrentElement.nextSibling);
      //         // }
      //       });
      //     }
      //   });
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Calendar.js